<template>
	<div class="head">
		<div class="my_head" :style='{"backgroundColor":headBackColor}' v-if="isHeadShow">
			<div class="head_content" >
				<div class="nav_left">
					<a style="color: #fff;font-size: 22px;">
						<img :src="require('@/assets/head/logo.png')" alt="" style='height: 40px;object-fit: contain;'>
						胖哒云游
					</a>
				</div>
				<div v-if="show" class="nav_right">
					<div :class="['nav_item',{'nav_item_active':activeIndex===0}]" @click="gopathHome">
						<a class="nav_item_href">首页</a>
					</div>
					<div v-if="!is_channel" :class="['nav_item',{'nav_item_active':activeIndex===1}]" @click="gopathGame">
						<a class="nav_item_href">云游戏</a>
					</div>
					<div  class='nav_item' @click="openRecharge">
						<a class="nav_item_href">充值</a>
					</div>
					<div :class="['nav_item',{'nav_item_active':activeIndex===3}]" @click="gopathDownload">
						<a  class="nav_item_href">下载</a>
					</div>
					<div :class="['nav_item',{'nav_item_active':activeIndex===4}]" @click="gopathHelp">
						<a  class="nav_item_href">帮助</a>
					</div>
					<div :class="['nav_item',{'nav_item_active':activeIndex===6}]" @click="gopathAboutUs">
						<a  class="nav_item_href">关于我们</a>
					</div>
					<div class="nav_item login_userInfo" v-show='usreInfo.phone' @mouseenter="mouseenter" @mouseleave="mouseleave">
						<div  style="display: flex;justify-content: space-around;" >
							<div style="margin-right:6px">
								<!-- <el-avatar size='medium' style='margin:22px 0px;' src="img/pngs/login_tx_2.png"></el-avatar> -->
								<el-image style='margin:21px 0px;width: 35px;height: 35px;' :src="require('@/assets/head/login_tx_2.png')"></el-image>
							</div>
							<div style="display: flex;flex-direction: column;">
								<div class="login_userInfo_text" style="margin-top: 20px;text-align: left;">{{usreInfo.phone2}}</div>
								<div class="login_userInfo_text" >
									所剩时长: 
									<span style="color: #F9DD4A;">{{usreInfo.tota_time | fitlerTime}}</span>
								</div>
							</div>
						</div>
						<transition name="el-fade-in-linear">
							<div class="suspension-part" v-show='suspensionShow' >
								<!-- <div class='suspension' :style='{"top":mrTop+"px","left":mrLeft+"px"}'> -->
								<div class='suspension'>
									<div class="btns">
										<el-button class='btn' @click='goDetails'>个人中心</el-button>
										<el-button class='btn' @click='loginOut'>退出</el-button>
									</div>
								</div>  
							</div>
						</transition>
					</div>
					<div class="nav_item login_btn" v-show='!usreInfo.phone'>
						<el-button   style='background-color: transparent;color: #fff;border-color: #fff;margin: 24px 0px;padding: 7px 35px;'
						@click.stop="showLoginDialog" class='login_btn_class'> 
							登录
						</el-button>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 个人中心悬浮框 -->
	
	</div>
</template>

<script>
	import Vue from 'vue';
	import {mapState} from 'vuex'
	import {Image,Avatar,Transfer} from 'element-ui';
	Vue.use(Image).use(Avatar).use(Transfer);
	export default{
		name:'toubu',
		filters:{
			fitlerTime (val) {
				return parseInt(val/3600) + "小时" + parseInt(val%3600/60) + "分钟"
			}
		},
		data(){
			return {
				activeIndex:0,
				beforePath:'',
				loginDialogShow:false,
				usreInfo:{
					
				},
				outShow:false,
				suspensionShow:false,
				mrTop:0,
				mrLeft:0,
				headBackColor:'transparent',
				isHeadShow:true,
				show: true
			}
		},
		computed: {
			...mapState({
				is_channel: (state) => state.is_channel,
			}),
		},
		created() {
			let that = this;
			that.getLoginInfo();
			if(localStorage['activeIndex']&& typeof localStorage['activeIndex']!='undefined'){
				that.activeIndex = Number(localStorage['activeIndex']);
			}
		},
		mounted() {
			let that = this;
			that.$bus.$on('setHeadColor',(val)=>{
				that.headBackColor = val;
			});
			setInterval(()=>{
				that.getLoginInfo();
			},10000)
			that.$bus.$on('setActiveIndex',(val)=>{
				that.activeIndex = val;
				localStorage.setItem('activeIndex',val);
			})
		},
		methods:{
			gopathHome(){
				let that = this;
				if(that.$route.name == 'home')return;
				that.$router.push('/');
				that.$bus.$emit('setActiveIndex',0);
			},
			gopathGame(){
				let that = this;
				if(that.$route.name == 'game')return;
				that.$router.push('/game.html');
				that.$bus.$emit('setActiveIndex',1);
			},
			gopathDownload(){
				let that = this;
				if(that.$route.name == 'download')return;
				that.$router.push('/download.html');
				that.$bus.$emit('setActiveIndex',3);
			},
			gopathHelp(){
				let that = this;
				if(that.$route.name == 'help')return;
				that.$router.push('/help.html');
				that.$bus.$emit('setActiveIndex',4);
			},
			goDetails(){
				let that = this;
				if(that.$route.name == 'userDetail')return;
				that.$router.push('/userDetail.html');
				that.$bus.$emit('setActiveIndex',5);
			},
			gopathAboutUs(){
				let that = this;
				if(that.$route.name == 'aboutUs')return;
				that.$router.push('/aboutUs.html');
				that.$bus.$emit('setActiveIndex',6);
			},
			showLoginDialog(){
				let that = this;
				that.$bus.$emit('loginDialogShow',true);
			},
			getLoginInfo(){
				let that = this;
				if(!localStorage['login']||localStorage['login']==null)return;
				let url = 'api/v1/cloud_pc/app/user_info';
				that.$req.post(url,{},)
				.then(res=>{
					if(res.data){
						let obj = res.data;
						let str = res.data.phone;
						
						obj.phone2 = str.substr(0,3)+'****'+str.substr(7,str.length);
						obj.surplus_coin = res.data.my_coin - res.data.used_coin + res.data.cy_count;
						obj.tota_time = obj.surplus_coin/5*60
						that.usreInfo = obj;
						that.$set(that.usreInfo,obj);
						// that.$bus.$emit("getUserInfo",that.usreInfo)
						Vue.prototype.GetUserInfo=that.usreInfo
						sessionStorage.setItem('userInfo',JSON.stringify(res.data));
					}else{
						// token 过期 默认清除登录信息 或者被其他设备登录时需要下线
						// localStorage.setItem('singleLogin',true);
						that.loginOut();
					}
				})
				.catch(err=>{
					console.error(err);
				})
			},

			loginOut(){
				let that = this;
				localStorage.removeItem('login');
				sessionStorage.removeItem('userInfo');
				// localStorage.clear();
				that.usreInfo = {};
				that.$set(that.usreInfo,{});
				// localStorage.setItem('activeIndex',0);
				if(that.$route.name == 'userDetail'){
					that.$router.push('/index.html');
					that.$bus.$emit('setActiveIndex',0);
					// location.reload();
				}else{
					location.reload();
				}
			},
			// 打开充值dialog
			openRecharge(){
				let that = this;
				if(that.$utils.checkLogin()){
					that.$utils.Burying({
						act: 'zhudongchongzhi',
						user_attribute: 'old',
						userID: JSON.parse(localStorage['login']).user_id,
						phone: that.usreInfo.phone,
						operating_system: 'web',
						Registration_time: that.usreInfo.create_time,
					});	
					that.$bus.$emit('RechargeDialogShow',true);
				}else{
					that.$bus.$emit('loginDialogShow',true);
				}
				
			},
			mouseenter(){
				let that = this;
				that.suspensionShow = true;
				// setTimeout(()=>{
					
				// 	that.mrLeft = document.querySelector('.login_userInfo').querySelector('.el-image').offsetLeft;
				// 	that.mrTop = 56;
				// 	that.suspensionShow = true;
				// },200)
			},
			mouseleave(){
				let that = this;
				// setTimeout(()=>{
				// 	that.outShow = false;
					
				// },200)
				that.suspensionShow = false;
				// setTimeout(()=>{
				// 	that.suspensionShow = false;
				// 	// that.mrLeft = 0;
				// 	// that.mrTop = 0;
				// },2500)
			},
			doDetails(){
				
			},
		},
		watch:{
			'$route':function(to){
				let that  =  this;
				that.isHeadShow=true;
				that.show = true
				switch(to.name){
					case "home":
						that.$bus.$emit('setActiveIndex',0);
						break;
					case "game":
						that.$bus.$emit('setActiveIndex',1);
						break;
					case "download":
						that.$bus.$emit('setActiveIndex',3);
						break;
					case "help":
						that.$bus.$emit('setActiveIndex',4);
						break;
					case "userDetail":
						that.$bus.$emit('setActiveIndex',5);
						break;
					case "aboutUs":
						that.$bus.$emit('setActiveIndex',6);
						break;
					case "gameDetail":
						that.$bus.$emit('setActiveIndex',1);
						break;
					case "downloadM":
						that.isHeadShow=false;
						break;
					case "gameActive":
						that.isHeadShow=false;
						break;
					case "downloadP":
						that.isHeadShow=true;
						this.show = false
						break;
					default:
						that.isHeadShow=false;
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.my_head{
		// display:none;
		// min-width: 1900px;
		width: 100%;
		height: 80px;
		// background: transparent;
		// background:#000;
		position: absolute;
		top: 0;
		z-index: 99;
		margin: 0 auto;
	}
	.head_content{
		width: 78%;
		max-width: 1200px;
		height: 80px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}
	.nav_left{
		float: left;
		width: 400px;
		height: 80px;
	}
	.nav_left a{
		height: 80px;
		line-height: 80px;
	}
	.nav_left a img{
		vertical-align: middle;
	}
	.nav_right{
		float: right;
		width: 800px;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
	}
	.nav_item{
		width: 100%;
		max-width: 100px;
		height: 80px;
		box-sizing: border-box;
		float: left;
		margin: 0px;
		cursor: pointer;
	}
	.login_userInfo{
		justify-content: space-around;
		max-width: 220px;
		font-size: 14px;
		width: auto;
		margin-left: 10px;
		.login_userInfo_text{
			color: #BFBFBF;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}
	.nav_item_active{
		border-bottom: #F9DD4A 4px solid;
	}
	.nav_item_href{
		font-size: 18px;
		color: #fff;
		text-align: center;
		display: block;
		height: 80px;
		line-height: 80px;
		text-decoration: none;
	}
	.nav_item_active .nav_item_href{
		color: rgba(249,221,74,1) !important;
	}
	.suspension-part{
		
		.suspension{
			position: absolute;
			top: 56px;
			width:131px;
			height:147px;
			background: url('../assets/head/suspension.png') no-repeat top;
			background-size: 113% 104%;
			z-index: 99;
			// filter: drop-shadow(10px 10px 4px #4444dd);
			.btns{
				width:131px;
				height: 100px;
				margin-top: 30px;
				/deep/
				.el-button+.el-button{
					margin-left: 0;
				}
				.btn{
					width:131px;
					height:50px;
					font-size:14px;
					font-family:PingFang SC;
					font-weight:400;
					line-height:20px;
					color:rgba(25,25,25,1);
					padding: 15px 37px;
					background-color: transparent;
					border: none;
					
				}
				.btn:hover{
					color:rgba(249,221,74,1);
					background-color: transparent;
					background:rgba(25,25,25,1);
				}
			}
		}
	}
	
	
	/* 小屏 */
	@media screen and (max-width:500px){
		.nav_left{
			float: left;
			width: 20%;
			height: 80px;
		}
		.nav_right{
			float: right;
			width: 80%;
			overflow: hidden auto;
		}
	}
</style>
